import { defineComponent as _defineComponent } from 'vue'
import { BaseText, Heading, Link } from '@warrenbrasil/nebraska-web';
import { ContentHTMLTags, IDynamicContent } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicContent',
  props: {
  title: {
    type: String,
    default: ''
  },
  content: {
    type: Array as () => IDynamicContent[],
    required: true
  }
},
  setup(__props) {



return { __sfc: true,BaseText, Heading, Link, ContentHTMLTags }
}

})